import { Typography } from '@vk-hr-tek/ui/Typography';

import { NotificationGroup } from '../../types';

import { NotificationItem, NotificationItemProps } from './NotificationItem';

interface NotificationGroupItemProps extends Omit<
  NotificationItemProps,
  'data'
> {
  data: NotificationGroup;
  onClose?: () => void;
}

export const NotificationGroupItem = ({
  data,
  variant = 'list',
  onClose,
  ...restProps
}: NotificationGroupItemProps) => {
  const isPluginVariant = variant === 'plugin';

  if (data.type === 'group') {
    return (
      <Typography
        variant={isPluginVariant ? 'subtitle2' : 'body2'}
        color="text.light.tertirary"
      >
        {data.label}
      </Typography>
    );
  }

  return (
    <NotificationItem
      data={data}
      variant={variant}
      onClose={onClose}
      {...restProps}
    />
  );
};
